'use client';

import { observer } from 'mobx-react-lite';
import useSearchPlaces from 'hooks/useSearchPlaces';
import SearchContent from 'components/Shared/SearchContent/SearchContent';
import SearchPlacesList from 'components/SearchPlacesList/SearchPlacesList';
import { ParamsResult } from 'ParamsResult.d';
import { SearchPlacesResult } from 'searchPlaces.d';
import { updateUrlQueryParam } from 'utils/misc';

export type SearchPlacesTemplateProps = {
  params: ParamsResult;
  searchDataResult: SearchPlacesResult;
  isMobile: boolean;
};

function SearchPlacesTemplate({ searchDataResult, params, isMobile }: SearchPlacesTemplateProps) {
  const searchPlacesStore = useSearchPlaces();
  searchPlacesStore.hydrate(searchDataResult);

  return (
    <SearchContent
      pageTypeText="lugares"
      searchResult={searchPlacesStore?.searchDataResult}
      totalPages={searchPlacesStore?.totalPages}
      isFetching={searchPlacesStore?.isFetching}
      isMobile={isMobile}
      onChangePage={(page: string | number) => {
        if (!isMobile) {
          updateUrlQueryParam({ param: 'page', value: String(page) });
        }
        searchPlacesStore.fetchPaginationData({
          query: window?.location?.search,
          isMobile,
          page,
          onSuccess: () => window?.scrollTo({ top: 0, left: 0 }),
        });
        return +page;
      }}
    >
      <SearchPlacesList places={searchPlacesStore?.searchDataResult?.data} serviceParams={params} />
    </SearchContent>
  );
}

export default observer(SearchPlacesTemplate);
